/**
 * COLLECTION POPUP - FINAL VERSION WITH CORRECT COLLECTION LOGIC
 */
console.log('=== COLLECTION POPUP SYSTEM INITIALIZING ===');

class CollectionPopup {
  constructor() {
    this.popup = document.getElementById('collection-popup');
    this.config = null;
    this.isPopupOpen = false;
    this.lastClickedButton = null;
    this.lastAddedProductHandle = null;
    
    console.log('Collection popup element found:', !!this.popup);
    
    this.init();
  }
  
  init() {
    console.log('=== INITIALIZING COLLECTION POPUP ===');
    
    this.loadConfig();
    this.setupPopupElements();
    this.setupEventListeners();
    this.setupAddToCartDetection();
    
    console.log('Collection popup initialized');
  }
  
  loadConfig() {
    try {
      const configElement = document.getElementById('collection-popup-config');
      if (configElement) {
        this.config = JSON.parse(configElement.textContent);
        console.log('✅ Collection popup config loaded');
        console.log('Popup-enabled collections:', Object.keys(this.config.collections || {}));
        
        if (this.config.collections) {
          Object.entries(this.config.collections).forEach(([handle, data]) => {
            console.log(`📦 Collection: ${handle} → Upsell: ${data.upsell_collection} (${data.upsell_products?.length || 0} products)`);
          });
        }
      } else {
        console.warn('⚠️ No collection popup config found');
      }
    } catch (error) {
      console.error('❌ Error loading collection popup config:', error);
    }
  }
  
  setupPopupElements() {
    if (!this.popup) {
      console.error('❌ Collection popup element not found');
      return;
    }
    
    this.closeButton = this.popup.querySelector('.popup-close');
    this.overlay = this.popup.querySelector('.popup-overlay');
    this.dontRemindCheckbox = this.popup.querySelector('.dont-remind-checkbox[data-popup-type="collection"]');
    
    console.log('Popup elements setup complete');
  }
  
  setupEventListeners() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.hidePopup());
    }
    
    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.hidePopup());
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.style.display !== 'none') {
        this.hidePopup();
      }
    });
    
    if (this.dontRemindCheckbox) {
      this.dontRemindCheckbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          this.disablePopupFor30Days();
        }
      });
    }
    
    this.setupPopupClickIgnore();
  }
  
  setupPopupClickIgnore() {
    if (this.popup) {
      this.popup.addEventListener('mousedown', (e) => {
        window.clickedInsideCollectionPopup = true;
        setTimeout(() => {
          window.clickedInsideCollectionPopup = false;
        }, 100);
        console.log('Click inside collection popup detected');
      });
    }
  }
  
  setupAddToCartDetection() {
    console.log('=== SETTING UP ADD-TO-CART DETECTION ===');
    
    this.setupButtonTracking();
    this.watchForSuccessNotifications();
    
    document.addEventListener('ajaxCart:afterAdd', (event) => {
      console.log('📦 ajaxCart:afterAdd event');
      if (event.detail?.handle) {
        setTimeout(() => {
          this.checkForCollectionPopup(event.detail.handle);
        }, 1000);
      }
    });
    
    document.addEventListener('cart:item-added', (event) => {
      console.log('🛒 cart:item-added event');
      if (event.detail?.productHandle) {
        setTimeout(() => {
          this.checkForCollectionPopup(event.detail.productHandle);
        }, 1000);
      }
    });
    
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.action?.includes('/cart/add')) return;

      console.log('📝 Form submission detected for collection popup');

      const productHandle = this.getProductHandleFromForm(form);
      if (productHandle) {
        console.log('📋 Form submission product handle:', productHandle);
        this.lastAddedProductHandle = productHandle;

        setTimeout(() => {
          this.checkForCollectionPopup(productHandle);
        }, 1200);
      }
    }, true);

    // Close this popup after a product is added from inside it. Uses PubSub
    // (fired by component-new-product-card.js after a successful add) instead
    // of intercepting the form submit directly, since the global add-to-cart
    // handler already owns that and would block a second listener here.
    if (window.PubSub) {
      window.PubSub.subscribe('cart-updated', () => {
        if (this.isPopupOpen) {
          setTimeout(() => this.hidePopup(), 1000);
        }
      });
    }

    console.log('Add-to-cart detection setup complete');
  }
  
  setupButtonTracking() {
    document.addEventListener('mousedown', (e) => {
      if (window.clickedInsidePopup || window.clickedInsideCollectionPopup) {
        console.log('Skipping button tracking - click was inside popup');
        return;
      }
      
      const button = e.target.closest(
        '.new-product-card__button, ' +
        '.s-new-products-grid__add-to-cart, ' +
        '.product-form__submit, ' +
        '[type="submit"][name="add"], ' +
        '.add-to-cart, ' +
        'button[data-add-to-cart]'
      );
      
      if (button) {
        this.lastClickedButton = button;
        console.log('📝 Add to cart button tracked (collection popup):', button);
        button.setAttribute('data-last-click', Date.now());
      }
    });
  }
  
  watchForSuccessNotifications() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.classList && node.classList.contains('cart-notification')) {
            if (node.classList.contains('success')) {
              console.log('✅ Success notification detected (collection popup)');
              this.findRecentlyAddedProduct();
            }
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  findRecentlyAddedProduct() {
    console.log('🔍 Finding recently added product for collection popup...');
    
    if (this.lastClickedButton) {
      const productHandle = this.getProductHandleFromButton(this.lastClickedButton);
      if (productHandle) {
        console.log('✅ Found product from tracked button:', productHandle);
        this.checkForCollectionPopup(productHandle);
        this.lastClickedButton = null;
        return;
      }
    }
    
    if (this.lastAddedProductHandle) {
      console.log('✅ Using last added product handle:', this.lastAddedProductHandle);
      this.checkForCollectionPopup(this.lastAddedProductHandle);
      this.lastAddedProductHandle = null;
      return;
    }
    
    const urlMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (urlMatch) {
      const productHandle = urlMatch[1];
      console.log('✅ On product page, using URL handle:', productHandle);
      this.checkForCollectionPopup(productHandle);
      return;
    }
    
    console.log('❌ Could not determine which product was added for collection popup');
  }
  
  getProductHandleFromButton(button) {
    console.log('🔍 Finding product handle from button (collection popup)');
    
    const urlMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (urlMatch) {
      return urlMatch[1];
    }
    
    const productCard = button.closest('.new-product-card');
    if (productCard) {
      if (productCard.dataset.productHandle) {
        return productCard.dataset.productHandle;
      }
      
      const productLink = productCard.querySelector('a[href*="/products/"]');
      if (productLink) {
        const match = productLink.href.match(/\/products\/([^\/?]+)/);
        if (match) {
          return match[1];
        }
      }
    }
    
    const form = button.closest('form');
    if (form) {
      const productHandleInput = form.querySelector('input[name="handle"], input[data-handle]');
      if (productHandleInput?.value) {
        return productHandleInput.value;
      }
      
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput?.dataset.handle) {
        return variantInput.dataset.handle;
      }
    }
    
    return null;
  }
  
  getProductHandleFromForm(form) {
    const productCard = form.closest('[data-product-handle]');
    if (productCard?.dataset.productHandle) {
      return productCard.dataset.productHandle;
    }
    
    const handleInput = form.querySelector('[data-handle], input[name="handle"]');
    if (handleInput?.value || handleInput?.dataset?.handle) {
      return handleInput.value || handleInput.dataset.handle;
    }
    
    const urlMatch = window.location.pathname.match(/\/products\/([^\/?]+)/);
    if (urlMatch) {
      return urlMatch[1];
    }
    
    return null;
  }
  
  checkForCollectionPopup(productHandle) {
      // ===== Prevent on cart =====
  if (window.location.pathname.includes('/cart')) {
    console.log('On cart page - popup disabled');
    return;
  }
    console.log('=== CHECKING COLLECTION POPUP FOR PRODUCT ===');
    console.log('Product handle:', productHandle);
    
    const originalPopup = document.getElementById('homepage-popup');
    if (originalPopup && originalPopup.style.display !== 'none') {
      console.log('❌ Original popup is showing, skipping collection popup');
      return;
    }
    
    if (this.isPopupOpen || !this.config) {
      console.log('❌ Skipping - collection popup already open or no config');
      return;
    }
    
    if (this.isPopupDisabled()) {
      console.log('❌ Collection popup disabled by user');
      return;
    }
    
    const matchingCollection = this.findMatchingCollection(productHandle);
    
    if (matchingCollection) {
      console.log('🎯 Found matching collection:', matchingCollection.handle);
      this.showPopup(matchingCollection);
    } else {
      console.log('❌ No matching collection found for product');
    }
  }
  
  // ===== FIXED METHOD - THIS IS THE IMPORTANT PART =====
  findMatchingCollection(productHandle) {
    if (!this.config?.collections) {
      return null;
    }
    
    console.log('🔍 Looking for popup-enabled collection containing product:', productHandle);
    
    // Method 1: Check product_collections mapping (most accurate)
    if (this.config.product_collections?.[productHandle]) {
      const productCollections = this.config.product_collections[productHandle];
      console.log('📋 Product belongs to these collections:', productCollections);
      
      for (const collectionHandle of productCollections) {
        // Check if THIS collection has popup enabled
        const collectionData = this.config.collections[collectionHandle];
        if (collectionData && collectionData.upsell_products?.length > 0) {
          console.log('✅ Product belongs to popup-enabled collection:', collectionHandle);
          console.log('   Upsell collection:', collectionData.upsell_collection);
          console.log('   Upsell products count:', collectionData.upsell_products.length);
          return collectionData;
        }
      }
    }
    
    // Method 2: Check if product is in the collection's product list
    console.log('🔍 Checking all popup-enabled collections...');
    for (const [collectionHandle, collectionData] of Object.entries(this.config.collections)) {
      // Check if the product belongs to this collection via product_collections
      if (this.config.product_collections?.[productHandle]?.includes(collectionHandle)) {
        console.log('✅ Product belongs to popup-enabled collection (verified):', collectionHandle);
        return collectionData;
      }
    }
    
    console.log('❌ Product does NOT belong to any popup-enabled collection');
    return null;
  }
  // ===== END OF FIXED METHOD =====
  
  showPopup(collectionData) {
    console.log('🎉 SHOWING COLLECTION POPUP ===');
    console.log('For collection:', collectionData.handle);
    console.log('With', collectionData.upsell_products?.length, 'upsell products');
    
    this.isPopupOpen = true;
    
    this.updatePopupContent(collectionData);
    
    this.popup.style.display = 'block';
    this.popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    
    console.log('✅ Collection popup displayed successfully');
  }
  
  updatePopupContent(collectionData) {
    console.log('Updating popup content');
    
    const icon = this.popup.querySelector('.popup-icon');
    const title = this.popup.querySelector('.popup-title');
    const subtitle = this.popup.querySelector('.popup-subtitle');
    const footerText = this.popup.querySelector('.footer-text');
    const productsGrid = document.getElementById('collection-popup-products-grid');
    const dontRemindText = this.popup.querySelector('.dont-remind-text');
    
    if (icon) {
      if (collectionData.popup_icon) {
        icon.src = collectionData.popup_icon;
        icon.style.display = 'block';
      } else {
        icon.style.display = 'none';
      }
    }
    
    if (title) title.textContent = collectionData.popup_title || 'You might also like...';
    if (subtitle) subtitle.textContent = collectionData.popup_subtitle || '';
    if (footerText) footerText.textContent = collectionData.popup_footer_text || '';
    
    if (dontRemindText && collectionData.is_arabic) {
      dontRemindText.textContent = 'لا تذكرني مرة أخرى';
    }
    
    if (productsGrid && collectionData.upsell_products) {
      this.renderAllProductsGrid(productsGrid, collectionData.upsell_products);
    }
  }
  
  renderAllProductsGrid(container, products) {
    console.log('🎨 Rendering ALL', products.length, 'products in grid');
    
    let gridHTML = '';
    const preloadedCards = document.getElementById('collection-popup-preloaded-cards');
    
    products.forEach(product => {
      let productCardHTML = '';
      let productFound = false;
      
      if (preloadedCards) {
        const preloadedCard = preloadedCards.querySelector(`[data-product-handle="${product.handle}"]`);
        if (preloadedCard) {
          productCardHTML = preloadedCard.outerHTML;
          productFound = true;
        }
      }
      
      if (!productFound) {
        const isArabic = document.documentElement.lang === 'ar' || document.documentElement.dir === 'rtl';
        const buttonText = product.available ? 
          (isArabic ? 'أضف إلى السلة' : 'Add to Cart') : 
          (isArabic ? 'إنتهى من المخزن' : 'Out of Stock');
        
        productCardHTML = `
          <div class="new-product-card" data-product-handle="${product.handle}">
            <div class="new-product-card__clickable-area">
              <a href="${product.url}" class="new-product-card__link">
                <div class="new-product-card__image-container" style="height: 200px;">
                  <img class="new-product-card__image" src="${product.featured_image}" alt="${product.title}" loading="lazy">
                </div>
                <div class="new-product-card__content">
                  <h3 class="new-product-card__title">${product.title}</h3>
                  <div class="new-product-card__price">
                  ${product.compare_at_price && product.compare_at_price !== product.price ? 
                    `<div class="price-container">
                      <span class="actual-price">${product.price}</span>
                      <span class="compare-price">${product.compare_at_price}</span>
                    </div>` : 
                    `<span class="regular-price">${product.price}</span>`
                  }
                </div>
                </div>
              </a>
            </div>
            <form action="/cart/add" method="post" class="new-product-card__form">
              <input type="hidden" name="id" value="${product.selected_variant_id || ''}">
              <button type="submit" class="new-product-card__button" ${!product.available ? 'disabled' : ''}>
                ${buttonText}
              </button>
            </form>
          </div>
        `;
      }
      
      gridHTML += `<div class="popup-grid-item">${productCardHTML}</div>`;
    });
    
    container.innerHTML = gridHTML;
  }

  isPopupDisabled() {
    const disabledUntil = localStorage.getItem('collection_popup_disabled');
    if (!disabledUntil) return false;
    
    const now = new Date().getTime();
    return now < parseInt(disabledUntil);
  }
  
  disablePopupFor30Days() {
    const thirtyDays = 30 * 24 * 60 * 60 * 1000;
    const disableUntil = new Date().getTime() + thirtyDays;
    localStorage.setItem('collection_popup_disabled', disableUntil.toString());
    console.log('Collection popup disabled for 30 days');
  }
  
  hidePopup() {
    if (!this.popup) return;
    
    console.log('Hiding collection popup');
    
    this.popup.style.display = 'none';
    this.popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    this.isPopupOpen = false;
    
    console.log('✅ Collection popup hidden');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('=== STARTING COLLECTION POPUP SYSTEM ===');
  window.collectionPopup = new CollectionPopup();
});